import React, { useEffect, useRef, useState } from 'react';
import { animate, easeInOut, motion, MotionValue, useMotionTemplate, useMotionValue, useTime, useTransform } from 'motion/react';
import { tryhardLogoPath } from '../../svg/SVGData';

const LandingTHGLogo: React.FC<any> = ({ clicked }) => {
    const scaleBase = 50;
    const scaleMultiplier = 1.5;
    const scaleProduct = scaleBase * scaleMultiplier;
    // const width = useMotionValue(`${scaleBase}%`);
    const height = useMotionValue(`${scaleBase}%`);

    const onMouseEnter: React.MouseEventHandler = () => { animate(height, `${scaleProduct}%`, { duration: .4, type: 'spring', bounce: .8, ease: "easeIn" }) }
    const onMouseLeave: React.MouseEventHandler = () => { animate(height, `${scaleBase}%`), { duration: .1, type: 'spring', bounce: .5 } }

    const x = useMotionValue<number | string>('200%');

    useEffect(() => {
        animate(x, '0%', { ease: 'easeIn', duration: .15 })
        animate(height, [`${scaleBase * 1.2}%`, `${scaleBase}%`], { ease: 'easeInOut', duration: 1, type: 'spring', bounce: 8 })
    }, [])

    return (
        <motion.svg
            // animate={{ x: 0, scale: [1.2, 1], transition: { type: 'spring', bounce: 5 }}}
            exit={clicked ? { rotateY: `${4 * 360}deg`, y: '-25%', transition: { duration: 1, ease: 'easeOut' } } : { y: '100%' }}
            style={{ x, height, filter: 'drop-shadow(0px 4px 8px rgba(255, 255, 255, 1))' }}
            className='drop-shadow-md z-30'
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            fill={'red'}
            viewBox="0 0 100 138" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d={tryhardLogoPath} />
        </motion.svg>
    )
}

interface SectionProps {
    hoverCB: Function,
    leaveCB: Function,
    height: MotionValue
}

const SectionTryhard: React.FC<SectionProps> = ({ height, hoverCB, leaveCB }) => {
    const barWidth = useMotionValue("0%");
    const phantomOpacity = useMotionValue(1);
    const bgBlur = useMotionValue(3);
    const filter = useMotionTemplate`blur(${bgBlur}px)`
    const handleOnHoverStart = () => {
        hoverCB();
        animate(barWidth, "100%", { duration: .35, ease: 'easeOut' })
        animate(phantomOpacity, 0, { duration: .3, ease: 'easeOut' })
        animate(bgBlur, 0)
    }

    const handleOnHoverEnd = () => {
        leaveCB();
        animate(barWidth, "0%", { duration: .25, ease: 'easeIn' })
        animate(phantomOpacity, 1, { duration: .3, ease: 'easeIn' })
        animate(bgBlur, 3)
    }

    const t = useTime();
    const tPrev = useRef(0);
    const progress = useRef(0); // 0 to 1
    const duration = 1250;
    const direction = useRef(1);
    const colorEase = useTransform(() => {
        let tDelta = t.get() - tPrev.current;
        let pDelta = (tDelta * direction.current) / duration;
        let newP = progress.current + pDelta;
        let oldP = progress.current;

        if (newP > 1 && oldP <= 1) {
            newP = 1;
            direction.current = -direction.current;
        } else if (newP < 0 && oldP >= 0) {
            newP = 0;
            direction.current = -direction.current;
        }

        progress.current = newP;
        tPrev.current = t.get();
        return easeInOut(progress.current);
    })
    const tryhardTextColor = useTransform(colorEase, [0, 1], ['#000000', '#b91c1c']);

    const [clicked, setClicked] = useState(false);

    return (
        <motion.div
            layout
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { ease: 'easeOut', duration: .5 } }}
            exit={{ opacity: 0 }}
            className='cursor-pointer w-full flex justify-center items-center bg-white relative overflow-hidden select-none'
            style={{ height }}
            onHoverStart={handleOnHoverStart}
            onHoverEnd={handleOnHoverEnd}
            onClick={() => setClicked(true)}
        >
            {/* Background */}
            <motion.div style={{ filter }} className='size-full absolute'>
                <motion.div className='size-full' style={{ backgroundImage: 'url("thg/bg/bg_landing.png")' }} />
            </motion.div>

            <LandingTHGLogo clicked={clicked} />

            {/* Bottom Bar Zone */}
            <motion.div className='h-2 w-full bg-gray-900 opacity-50 bottom-0 left-0 absolute' />
            <motion.div style={{ width: barWidth }} className='bottom-0 left-0 absolute z-10'>
                {/* Phantom text */}
                <motion.div style={{ opacity: phantomOpacity }} className='absolute bottom-0 left-0 pb-2 px-4'>
                    <h2 className='text-3xl lg:text-4xl text-sun text-gray-300 min-w-max z-10'>TRYHARD GAMING</h2>
                </motion.div>
                <motion.div style={{ opacity: phantomOpacity }} className='absolute bottom-0 left-0 pb-2 px-4'>
                    <h2 className='text-3xl lg:text-4xl text-sun text-gray-700 min-w-max z-30 text-transparent'>TRYHARD GAMING</h2>
                </motion.div>
                <div className='flex drop-shadow-md justify-end'>
                    <motion.h2 style={{
                        color: tryhardTextColor,
                        filter: 'drop-shadow(0px 4px 12px rgba(0, 0, 0, .5))'
                    }} className='pr-4 drop-shadow-md text-3xl lg:text-4xl text-sun min-w-max relative z-20'>TRYHARD GAMING</motion.h2>
                </div>
                <div className='h-2 bg-black' />
            </motion.div>
        </motion.div>
    )
}

export default SectionTryhard;